
import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const JobHeroSection = () => {
  const { t } = useTranslation('jobs');
  return (
    <section className="relative overflow-hidden" style={{ contain: 'paint' }}>
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-secondary opacity-95 pointer-events-none"></div>
      <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 via-transparent to-accent/10 pointer-events-none"></div>
      {/* Dark theme overlay for perfect text contrast */}
      <div className="absolute inset-0 hero-dark-overlay opacity-70 [data-theme='dark']:opacity-100 pointer-events-none"></div>
      <div className="relative container mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="text-center">
          <motion.div 
            className="inline-flex items-center px-4 py-2 bg-accent/10 rounded-full border border-accent/20 mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Icon name="Briefcase" size={20} className="text-accent mr-2" />
            <span className="text-accent font-medium text-sm">{t('title', 'Careers at PC Centar')}</span>
          </motion.div>
          <motion.h1 
            className="font-heading font-bold text-4xl lg:text-5xl xl:text-6xl text-foreground leading-tight mb-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {t('subtitle', 'Join our team')}
            <span className="block text-accent mt-2">PC Centar {t('teamtext', 'team')}</span>
          </motion.h1>
          <motion.p 
            className="text-text-secondary text-lg lg:text-xl leading-relaxed max-w-3xl mx-auto mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            {t('description', 'PC Centar is looking for talented and motivated people to join our team of 100+ experts. As part of ComputerLand Group, we offer great opportunities for professional development.')}
          </motion.p>
          <motion.div 
            className="flex flex-wrap justify-center gap-6 mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-success rounded-full"></div>
              <span className="text-text-secondary font-medium">{t('stats.yearsExperience', '33+ years experience')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-accent rounded-full"></div>
              <span className="text-text-secondary font-medium">{t('stats.group', 'ComputerLand Group')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-warning rounded-full"></div>
              <span className="text-text-secondary font-medium">{t('stats.employees', '100+ employees')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-success rounded-full"></div>
              <span className="text-text-secondary font-medium">{t('leadingDistributor', 'Leading Distributor')}</span>
            </div>
          </motion.div>
          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <button 
              className="px-8 py-3 bg-accent text-accent-foreground rounded-lg font-body font-medium hover:bg-accent/90 transition-colors duration-300 flex items-center justify-center space-x-2"
              onClick={() => document.getElementById('hexagon-jobs-section')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <Icon name="ArrowDown" size={20} />
              <span>{t('positions', 'Otvorene pozicije')}</span>
            </button>
            <button 
              className="px-8 py-3 border border-accent text-accent rounded-lg font-body font-medium hover:bg-accent/10 transition-colors duration-300 flex items-center justify-center space-x-2"
              onClick={() => document.getElementById('job-application-form')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <Icon name="FileText" size={20} />
              <span>{t('apply', 'Prijavi se')}</span>
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default JobHeroSection;
